
import { useState, useEffect } from 'react';
import { useToast } from '@/components/ui/use-toast';
import { getCurrentUserOrganizationId } from '@/lib/supabase/products';

export const useOrganizationId = () => {
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchOrgId = async () => {
      try {
        setLoading(true);
        const orgId = await getCurrentUserOrganizationId();
        console.log("Retrieved organization ID:", orgId);
        
        if (orgId) {
          console.log("Setting organization ID:", orgId);
          setOrganizationId(orgId);
        } else {
          console.error("Failed to get organization ID");
          toast({
            title: "Erreur",
            description: "Impossible de récupérer l'identifiant de l'organisation",
            variant: "destructive"
          });
        }
      } catch (error) {
        console.error("Error fetching organization ID:", error);
        toast({
          title: "Erreur",
          description: "Impossible de récupérer l'identifiant de l'organisation",
          variant: "destructive"
        });
      } finally {
        setLoading(false);
      }
    };
    
    fetchOrgId();
  }, [toast]);

  return { organizationId, loading };
};
